import { CaseData } from '../../models/case-data.model';
import { Component, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CasesService } from 'src/app/services/cases/cases.service';
import { HeaderComponent } from './header/header.component';
import { DetailsComponent } from './details/details.component';
import { CountdownComponent } from './countdown/countdown.component';
import { ClaimsListComponent } from './claims-list/claims-list.component';
import { MatDivider } from '@angular/material/divider';
import { DepositComponent } from './deposit/deposit.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'app-microsite',
  templateUrl: './microsite.component.html',
  styleUrls: ['./microsite.component.scss'],
  imports: [
    HeaderComponent,
    DetailsComponent,
    CountdownComponent,
    ClaimsListComponent,
    MatDivider,
    DepositComponent,
    FooterComponent,
  ],
})
export class MicrositeComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private casesService = inject(CasesService);

  docID: string;
  readonly loading = signal(false);
  securityCode: string;
  caseData: CaseData;
  claimsListOpen = false;

  get windowWidth() {
    return window.innerWidth;
  }

  constructor() {
    this.docID = this.route.snapshot.params.docID;
  }

  async ngOnInit() {
    if (!this.docID) {
      window.location.assign('https://payee.tech/');
      return;
    }

    const loadingTimer = setTimeout(() => this.loading.set(true), 250);
    try {
      this.caseData = await this.casesService.getCaseDataByKey(this.docID);
    } catch {
      window.location.assign('https://payee.tech/');
    } finally {
      clearTimeout(loadingTimer);
      this.loading.set(false);
    }

    if (this.caseData.is_closed) {
      if (this.caseData.is_paid) {
        return await this.router.navigate(['already-paid']);
      } else {
        return await this.router.navigate(['case-deleted']);
      }
    }

    if (
      this.caseData.stage !== 'ONGOING' ||
      this.caseData.product !== 'notice'
    ) {
      await this.router.navigate(['case-deleted']);
    }

    this.loading.set(false);
  }

  redirectToBarionGatewayUrl(gatewayUrl: string) {
    window.location.href = gatewayUrl;
  }

  async generateToken() {
    throw new Error('Unimplemented');
  }

  async getCaseDataByToken() {
    throw new Error('Unimplemented');
  }

  async getCaseDataByKey() {
    throw new Error('Unimplemented');
  }

  isCasePaused(): boolean {
    return false;
  }

  toggleClaimsList() {
    this.claimsListOpen = !this.claimsListOpen;
  }
}
